


const TransitionOverlay:React.FC = () => {
    return (
        <div className="transition--overlay fixed w-full h-full bg-violet-800 z-50 top-0 left-[100%]">

        </div>
    );
}
 
export default TransitionOverlay;